import { render } from "./TermsAndConditions.vue?vue&type=template&id=18facc0d&scoped=true"
const script = {}

import "./TermsAndConditions.vue?vue&type=style&index=0&id=18facc0d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18facc0d"]])

export default __exports__